import React, { useCallback } from 'react';
import { useLogger } from '@direct-frontend/modules-logger';
import { genericForwardRef, genericMemo } from '@direct-frontend/stdlib';

import { BoxProps, CheckboxBase } from '../CheckboxBase';

import { CheckboxProps } from './types';
import { Box } from './Box/Box';

/**
 * Компонент для создания чекбоксов
 */
export const Checkbox = genericMemo(
    genericForwardRef<HTMLElement, CheckboxProps>(function Checkbox(props, ref) {
        const { logNode, onChange, ...baseProps } = props;

        const { LogProvider, logClick } = useLogger('Checkbox', logNode);
        const handleChange = useCallback(
            (isSelected: boolean) => {
                logClick({ isSelected });

                onChange?.(isSelected);
            },
            [onChange, logClick],
        );
        const renderBox = useCallback((boxProps: BoxProps) => <Box {...boxProps} />, []);

        return (
            <LogProvider>
                <CheckboxBase {...baseProps} labelRef={ref} onChange={handleChange} renderBox={renderBox} />
            </LogProvider>
        );
    }),
);
